import Model from '@/lib/data/Model';

class Account extends Model {
    static idProperty = 'id';

    fields = ['id', 'account_name', 'organization_id'];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'remove',
            method: 'DELETE',
            url: '/customer/account/delete',
            params: ['id'],
        },
    ];
}

export default Account;
